import { nullFn } from '@op/util'
import { componentResolver } from '../../components'
import { resolveBaseManagePage } from './resolveBaseManagePage'

export const ManageBasePage = /*@__PURE__*/ componentResolver(resolveBaseManagePage, nullFn)
